import axios from '@/axios/axios2'

// 认证失败列表
export const storeAssistEntryGetAssistEntryList = params =>
  axios.post('/storeAssistEntry/getAssistEntryList', params)

// 协助进件查询机具列表
export const storeAssistEntryGetMachineList = params =>
  axios.post('/storeAssistEntry/getMachineList', params)

// 查询协助进件详情接口
export const storeAssistEntryGetAssistEntryDetail = params =>
  axios.post('/storeAssistEntry/getAssistEntryDetail', params)

// 营业执照OCR
export const storeAssistEntryBusinessLicenseOcr = params =>
  axios.post('/storeAssistEntry/businessLicenseOcr', params)
// 查询经营类型
export const storeAssistEntryGetBizTypeList = params =>
  axios.post('/storeAssistEntry/getBizTypeList', params)
// 省市区
export const commonFindCityDistrict = params =>
  axios.post('/common/findCityDistrict', params)
// 正地理编码接口
export const commonGetLngAndLat = params =>
  axios.post('/common/getLngAndLat', params)
// 地图经纬度查询地址接口
export const commonSelectAddr = params =>
  axios.post('/common/selectAddr', params)
// 协助进件提交接口
export const storeAssistEntrySubmitEntry = params =>
  axios.post('/storeAssistEntry/submitEntry', params)
